export default __webpack_public_path__ + "static/media/monnifyLogo.a3abe32c.png";